import type { TourConfig } from '../types';

export const revisionsTour: TourConfig = {
  name: 'revisions',
  autoStart: true,
  steps: [
    {
      target: '[data-tour="revisions-tabs"]',
      title: 'Content Types',
      content:
        'Switch between Videos and Shorts/Reels. Organize your content based on the type of video you are creating.',
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '[data-tour="revisions-folders"]',
      title: 'Folder Organization',
      content:
        'Your content is organized in folders. Click on a folder to see all assets inside it.',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour="revisions-upload"]',
      title: 'Upload Videos',
      content:
        'Drag and drop your video files here to create a new asset. You can also click to browse files.',
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '[data-tour="revision-card"]',
      title: 'Asset Card',
      content:
        'Each card represents a video asset. Click to view drafts, versions, and collaborate with your team.',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour="revision-actions"]',
      title: 'Asset Actions',
      content:
        'Manage your assets here. Delete, move to different folders, or share with external reviewers.',
      placement: 'left',
      disableBeacon: true,
    },
  ],
};
